<template lang="pug">
  #ch4grid.container-fluid
    .row.d-flex.justify-content-center.align-items-center
      .col-1.mt-4
      .col-11.mt-4
        p.compare {{compare ? 'Compara con otro perfil:': ''}}
      .col-12.col-lg-4.desktop.mt-4.d-flex.flex-column.justify-content-center.align-items-start.filter
        p.py-1.mb-2 {{compare ? 'Sexo' : '¿Cuál es tu sexo?'}}
        select.form-control(v-model="gender")
          option(:value="g" v-for="g in genders") {{g}}
      .col-12.col-lg-6.desktop.mt-4.d-flex.flex-column.justify-content-center.align-items-start.filter
        p.py-1.mb-2 {{compare ? 'Escolaridad' : '¿Cuál es tu escolaridad?'}}
        select.form-control(v-model="education")
          option(:value="e" v-for="e in educations") {{e}}
      .col-12.col-lg-6.desktop.mt-4.d-flex.flex-column.justify-content-center.align-items-start.filter
        p.py-1.mb-2 {{compare ? 'Rango de edad' : '¿Cuál es tu rango de edad?'}}
        select.form-control(v-model="age")
          option(:value="a" v-for="a in ages") {{a}}
      .col-12.mt-3.d-flex.justify-content-center
        p.d-inline.px-4.py-2.text-center.description
          span El&nbsp;
          span(:class="disease") {{percentage}}%&nbsp;
          span de las personas&nbsp;
          span(:class="disease") {{compare ? 'con este perfil': 'como tú'}}&nbsp;
          span padecen de {{disease === 'hipertension' ? 'hipertensión' : disease}}
      .col-12.icons
        .d-flex.justify-content-center.align-items-center.flex-wrap
          Illustration.px-1.my-1(src="/assets/img/chapter4/person_icon.svg" :class="disease" v-for="t in percentage")
          Illustration.px-1.my-1.gray(src="/assets/img/chapter4/person_icon.svg" v-for="t in 100 - percentage")
</template>

<script>
import * as d3 from "d3";
import * as _ from "lodash";
import Illustration from "@/components/Illustration.vue";

export default {
  name: "ch4grid",
  props: {
    compare: Boolean
  },
  components: {
    Illustration
  },
  data() {
    return {
      data: [],
      percentage: 0,
      gender: "",
      genders: [],
      education: "",
      educations: [],
      age: "",
      ages: []
    };
  },
  watch: {
    gender() {
      this.load();
    },
    education() {
      this.load();
    },
    age() {
      this.load();
    },
    disease() {
      this.load();
    }
  },
  computed: {
    disease: {
      get() {
        return this.$store.state.disease;
      },
      set(newValue) {
        this.$store.state.disease = newValue;
      }
    }
  },
  methods: {
    load() {
      this.percentage = _.round(
        Number(
          _.find(this.data, {
            g_edad2: this.age,
            nivel: this.education,
            sexo: this.gender
          })[this.disease]
        ),
        0
      );
    }
  },
  async mounted() {
    this.data = await d3.csv("/assets/csv/chapter4/enfermedades.csv");
    this.genders = d3
      .nest()
      .key(d => d.sexo)
      .entries(this.data)
      .map(g => g.key);
    this.gender = this.genders[0];

    this.educations = d3
      .nest()
      .key(d => d.nivel)
      .entries(this.data)
      .map(g => g.key);
    this.education = this.educations[0];

    this.ages = d3
      .nest()
      .key(d => d.g_edad2)
      .entries(this.data)
      .map(g => g.key);
    this.age = this.ages[0];
    /*this.generations = generations
      .map(g => g.key)
      .sort(
        (a, b) =>
          Number(a.split("De ")[1].substring(0, 2)) -
          Number(b.split("De ")[1].substring(0, 2))
      );
    this.generation = this.generations[0];
    this.data = generations;*/
    //console.log(this.data);
    this.percentage = _.round(
      Number(
        _.find(this.data, {
          g_edad2: this.age,
          nivel: this.education,
          sexo: this.gender
        })[this.disease]
      ),
      0
    );
    this.load();
  }
};
</script>

<style lang="scss">
#ch4grid {
  //height: 100vh;
  background-color: #0a1d59;
  .compare {
    font-family: "Inria Sans", sans-serif;
    font-size: 19px;
    font-weight: bold;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff;
  }
  .filter {
    p {
      font-family: "Inria Sans", sans-serif;
      font-size: 19px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;
    }
    select {
      -webkit-appearance: button;
      -moz-appearance: button;
      -webkit-user-select: none;
      -moz-user-select: none;
      -webkit-padding-end: 20px;
      -moz-padding-end: 20px;
      -webkit-padding-start: 20px;
      -moz-padding-start: 20px;
      background-color: transparent; /* Fallback color if gradients are not supported */
      //background-image: url(../images/select-arrow.png), -webkit-linear-gradient(top, #E5E5E5, #F4F4F4); /* For Chrome and Safari */
      //background-image: url(../images/select-arrow.png), -moz-linear-gradient(top, #E5E5E5, #F4F4F4); /* For old Firefox (3.6 to 15) */
      //background-image: url(../images/select-arrow.png), -ms-linear-gradient(top, #E5E5E5, #F4F4F4); /* For pre-releases of Internet Explorer  10*/
      //background-image: url(../images/select-arrow.png), -o-linear-gradient(top, #E5E5E5, #F4F4F4); /* For old Opera (11.1 to 12.0) */
      //background-image: url(../images/select-arrow.png), linear-gradient(to bottom, #E5E5E5, #F4F4F4); /* Standard syntax; must be last */
      background-position: center right;
      background-repeat: no-repeat;
      border: 2px solid #ffffff;
      border-radius: 2px;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
      color: #ffffff;
      //width: 427px;
      text-align: center;
      text-align-last: center;
      -moz-text-align-last: center;
      font-family: "Inria Sans", sans-serif;
      font-size: 20px;
      font-weight: 600;
      margin: 0;
      overflow: hidden;
      padding-top: 2px;
      padding-bottom: 2px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .description {
    font-family: "Inria Sans", sans-serif;
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    .obesidad {
      color: #ff6561;
    }
    .diabetes {
      color: #f0bf5f;
    }
    .hipertension {
      color: #34afb2;
    }
  }
  .icons {
    .obesidad {
      g {
        fill: #ff6561;
      }
    }
    .diabetes {
      g {
        fill: #f0bf5f;
      }
    }
    .hipertension {
      g {
        fill: #34afb2;
      }
    }
    .gray {
      g {
        fill: #b8b8b8;
      }
    }
  }
}

@media (max-width: 768px) {
  #ch2section1 {
    .mobile {
      display: block !important;
      select {
        width: 100%;
        margin: 0 auto;
        max-width: 340px;
      }
    }
    .desktop {
      display: none !important;
    }
  }
}
</style>
